import React from 'react'
import styled from 'styled-components'

export default function ViewOrderComplete() {
  return (
      <ContentViewOrder>ViewOrderComplete</ContentViewOrder>
  )
}


const ContentViewOrder = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* min-height: 100vh; */
    height: 100vh;
    background:white;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
    z-index:4;
    header {
        width: 100%;
        position: fixed;
        top: 0;
        padding: 1em 0;
        background: white;
        border-bottom: 1px solid #ecf0f1;
        color: #2c3e50;
        z-index:1;
    }
`